import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as downSmall } from './index2.js';
import { d as defineCustomElement$2 } from './pds-icon2.js';

const pdsAccordionCss = ":host{display:block}details{--number-animation-transform-timing:200ms;border-radius:var(--pine-dimension-xs)}details pds-icon{-webkit-transform:scaleY(1);transform:scaleY(1)}details[open]{background-color:var(--pine-color-background-container)}details[open] summary{color:var(--pine-color-text-active);font-weight:var(--pine-font-weight-semi-bold)}details[open] summary pds-icon{-webkit-transform:scaleY(-1);transform:scaleY(-1)}summary{background-color:var(--pine-color-background-container);border-radius:var(--pine-dimension-xs);color:var(--pine-color-text-readonly);font-family:var(--pine-font-family-body);font-size:var(--pine-font-size-body-md);font-weight:var(--pine-font-weight-medium);letter-spacing:var(--pine-letter-spacing);line-height:var(--pine-line-height-body);padding-block:calc(var(--pine-dimension-2xs) * 1.5);-webkit-padding-end:var(--pine-dimension-2xs);padding-inline-end:var(--pine-dimension-2xs);-webkit-padding-start:var(--pine-dimension-xs);padding-inline-start:var(--pine-dimension-xs);-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex}summary::-webkit-details-marker{display:none}summary:hover{background:var(--pine-color-background-container-hover);color:var(--pine-color-text);cursor:pointer}summary:focus-visible{outline:var(--pine-outline-focus);position:relative}summary pds-icon{-webkit-margin-start:auto;margin-inline-start:auto}.pds-accordion__body{-webkit-padding-after:calc(var(--pine-dimension-sm) + 2);padding-block-end:calc(var(--pine-dimension-sm) + 2);padding-inline:calc(var(--pine-dimension-2xs) * 1.5)}";

const PdsAccordion$1 = /*@__PURE__*/ proxyCustomElement(class PdsAccordion extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Can be used to manually set the open state of the accordion.
         * @defaultValue false
         */
        this.isOpen = false;
        this.handleToggle = () => {
            this.isOpen = this.detailsEl.open;
        };
        this.getOpenAttribute = () => {
            if (this.isOpen !== false) {
                return { open: true };
            }
            return '';
        };
    }
    handleOpenState(newValue) {
        this.isOpen = newValue;
    }
    componentDidLoad() {
        this.detailsEl.addEventListener('toggle', this.handleToggle);
    }
    render() {
        return (h(Host, { key: '92a6e19b0376d9cc14a86c9dda2fbfeef11297e3', class: "pds-accordion", id: this.componentId }, h("details", Object.assign({ key: '0bb94526cebdcefcec62976c1623ef208aaa3119' }, this.getOpenAttribute(), { ref: (el) => (this.detailsEl = el) }), h("summary", { key: 'b599fe5da538efde146be5ff8db8a04faf5c6c1b', part: "accordion-button" }, h("slot", { key: '8bdfa4448b41da6fd46232fe854f7c475fc633bf', name: "label" }, "Details"), h("pds-icon", { key: 'ca51ab8291047c08cef21ef55c85a8a47f8cb3e0', icon: downSmall })), h("div", { key: '628dc7ce9263bbd983fc2353181e31b6fca0176a', part: "accordion-body", class: "pds-accordion__body" }, h("slot", { key: '314d59312a3fbb2cc8a1c4d8a7f55634d16b079d' })))));
    }
    static get watchers() { return {
        "isOpen": ["handleOpenState"]
    }; }
    static get style() { return pdsAccordionCss; }
}, [1, "pds-accordion", {
        "componentId": [1, "component-id"],
        "isOpen": [1540, "open"]
    }, undefined, {
        "isOpen": ["handleOpenState"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-accordion", "pds-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-accordion":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsAccordion$1);
            }
            break;
        case "pds-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PdsAccordion = PdsAccordion$1;
const defineCustomElement = defineCustomElement$1;

export { PdsAccordion, defineCustomElement };
//# sourceMappingURL=pds-accordion.js.map

//# sourceMappingURL=pds-accordion.js.map